import { inject, type App } from 'vue'

import { translation } from '@/utils'
import type { BundleType } from '@/types/bundle'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $t (key: string, values?: object): string
    $bt (key: string, bundleType: BundleType, values?: object): string
    $url (path: string): string
  }
}

export const key = Symbol('translation')
export const useI18n = () => inject(key)

export const i18nPlugin = {
  install (app: App, prefix?: string) {
    const locale = () => {
      const { locale } = app.config.globalProperties.$theme || { locale: 'en' }
      return locale
    }

    const translate = (key: string, values = {}) => {
      key = key.startsWith('/') ? key.replace(/^\//, '') : prefix ? `${prefix}.${key}` : key
      // TODO: remove conditional below once bundler is sunset
      return translation(key, locale(), values)
    }

    const bundleTranslate = (key: string, bundleType: BundleType, values = {}) => {
      return translate(`bundler.${bundleType}.${key}`, values)
    }

    app.provide(key, translate)
    app.config.globalProperties.$t = translate
    app.config.globalProperties.$bt = bundleTranslate

    app.config.globalProperties.$url = (path: string) => locale() === 'es' ? `/es${path}` : path
  }
}

export default i18nPlugin
